import {
  amber, grey, common,
} from '@mui/material/colors';

export default (server) => {
  const colors = {
    white: common.white,
    background: grey[500],
    primary: server?.attributes?.colorPrimary || '#e6aa00',
    secondary: server?.attributes?.colorSecondary || '#75c602',
    positive: '#75c602',
    medium: amber[700],
    negative: '#b70101',
    neutral: grey[500],
    geometry: '#06ccc0',
  };

  return {
    background: {
      default: colors.background,
    },
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
      contrastText: colors.white,
    },
    colors,
  };
};
